import { jsx as _jsx } from "react/jsx-runtime";
const Error = ({ message }) => (_jsx("div", { children: message }));
export default Error;
//# sourceMappingURL=Error.js.map